import { IDuplicateCaseRepository } from '../ports/outbound/IDuplicateCaseRepository';
import { DuplicateCaseLookupResult } from '../domain/entities/DuplicateCaseLookupResult';

export class FetchDuplicateCaseLookupsUseCase {
  constructor(private readonly duplicateCaseRepository: IDuplicateCaseRepository) {}

  async execute(everifyCaseDuplicateId: string): Promise<DuplicateCaseLookupResult> {
    return this.duplicateCaseRepository.fetchDuplicateCaseLookups(everifyCaseDuplicateId);
  }
}
